export default __webpack_public_path__ + "static/media/morning.63aa69cc.svg";